/* Poster-first video. Third-party players are only fetched on activation. */
(function () {
  'use strict';

  class Video extends HTMLElement {
    connectedCallback() {
      this.poster = this.querySelector('[data-video-play]');
      this.target = this.querySelector('[data-video-target]');
      this.native = this.querySelector('video');

      if (this.poster) this.poster.addEventListener('click', () => this.play());

      this.querySelectorAll('[data-video-seek]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const t = parseInt(btn.dataset.videoSeek, 10) || 0;
          this.play(t);
        });
      });

      // Ambient clips (muted, looping, no controls) may start on their own —
      // but never when the visitor has asked for reduced motion or data saving.
      if (this.dataset.ambient === 'true' && this.native) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const saveData = navigator.connection && navigator.connection.saveData;
        if (!reduce && !saveData) {
          this.native.muted = true;
          this.play();
        }
      }
    }

    play(seconds) {
      this.dataset.playing = 'true';

      if (this.native) {
        if (typeof seconds === 'number') this.native.currentTime = seconds;
        const attempt = this.native.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
        return;
      }

      const url = this.dataset.external;
      if (!url || !this.target) return;

      if (!this.iframe) {
        this.iframe = document.createElement('iframe');
        this.iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        this.iframe.setAttribute('allowfullscreen', '');
        this.iframe.setAttribute('title', this.getAttribute('data-title') || 'Video');
        this.iframe.className = 'video__el';
        this.iframe.loading = 'lazy';
        this.target.appendChild(this.iframe);
      }

      this.iframe.src = this.buildSrc(url, seconds);
    }

    buildSrc(url, seconds) {
      const type = this.dataset.externalType;
      const id = this.dataset.externalId;
      const start = typeof seconds === 'number' ? seconds : 0;

      if (type === 'youtube' && id) {
        return (
          'https://www.youtube-nocookie.com/embed/' +
          id +
          '?autoplay=1&rel=0&modestbranding=1&playsinline=1&start=' +
          start
        );
      }
      if (type === 'vimeo' && id) {
        return 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1#t=' + start + 's';
      }
      return url;
    }
  }

  if (!customElements.get('tb-video')) customElements.define('tb-video', Video);
})();
